import React from "react";
import PatientInfoCard from "./PatientInfoCard";
import { Col } from "react-bootstrap";
const PreauthorizationRequrestPatientInfo = () => {
  return (
    // <Col xs={12} xl={2}>
    <PatientInfoCard />
    // </Col>
  );
};

export default PreauthorizationRequrestPatientInfo;
